import React from "react";
import profile from "../../Assets/profile/profile.jpg";

const About = () => {


  const handleClickCv = () => {
    window.open("https://drive.google.com/file/d/1JdTUjoay9ChPdQnCp1Y9o6GoD6dq-nTo/view?usp=sharing");
  }
  return (
    <div className=" min-h-screen bg-accent">
      <div className="pl-5 pt-20">
        <h2 className="text-4xl font-bold uppercase text-white border-l-4 border-primary pl-3">
          About me
        </h2>
        <span class="text-6xl font-semibold hover:font-bold uppercase text-base-100">
          About me
        </span>
      </div>
      <div class="hero min-h-screen">
        <div class="hero-content flex-col lg:flex-row">
          <img
            src={profile}
            class="w-100 rounded-lg shadow-2xl"
          />
          <div className="pl-10">
            <h2 class="text-5xl font-bold">I am <span className="text-primary">Saiful .</span> </h2>
            <p class="py-6 font-semibold">
              I am a junior web developer. Expert in html css, Bootstrap, tailwind-css, REST API,  javascript ES6 .familer React Js Backend techonology Nodejs, Express, Mongodb, Redux, Firebase.
            </p>
          
            <div className="grid grid-cols-2 gap-0">
              <h4>Full-Name</h4>
              <h4>: Saiful islam</h4>
            </div>
            <div className="grid grid-cols-2 gap-0">
              <h4>Age</h4>
              <h4>: 23</h4>
            </div>
            <div className="grid grid-cols-2 gap-0">
              <h4>Nationality</h4>
              <h4>: Bangladeshi</h4>
            </div>
            <div className="grid grid-cols-2 gap-0">
              <h4>Languages</h4>
              <h4>: English, Bangla</h4>
            </div>
            <div className="grid grid-cols-2 gap-0">
              <h4>Address</h4>
              <h4>: Mirpur-14, Dhaka, Bangladesh</h4>
            </div>

            <button onClick={handleClickCv} class="btn btn-primary mt-5">DOWNLOAD CV</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
